import { render, staticRenderFns } from "./simple-marquee.vue?vue&type=template&id=3a259f9c&scoped=true&lang=pug"
import script from "./simple-marquee.vue?vue&type=script&lang=coffee"
export * from "./simple-marquee.vue?vue&type=script&lang=coffee"
import style0 from "./simple-marquee.vue?vue&type=style&index=0&id=3a259f9c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a259f9c",
  null
  
)

export default component.exports